import { getIntroAlertObject } from '../../../login/src/form/getIntroAlertObject.js';
import { setElementVisible } from '../../../shared/DOM/setElementVisible.js';

/**
 * En este módulo incluímos los métodos relacionadoa con el view del ViewdocsFrom
 *
 * @returns Viewdocs View json
 */

export function getViewdocsView() {
  return {
    properties: [
      {
        type: 'object',
        name: 'index.html',
        cols: 4,
        properties: [
          {
            name: 'viewdocsAlert',
            type: 'alert',
            metadata: {
              closable: false,
              style: 'danger',
            },
            cols: 8,
          },
          {
            model: 'user',
            title: edicom.locale.translate('login.user'),
            placeholder: edicom.locale.translate('login.user'),
            type: 'string',
            disabled: true,
            metadata: {
              icon: 'user',
            },
            cols: 8,
          },
          {
            model: 'password',
            title: edicom.locale.translate('login.password'),
            placeholder: edicom.locale.translate('login.password'),
            type: 'password',
            required: true,
            cols: 8,
          },
          {
            name: 'btnSubmit',
            type: 'button',
            title: edicom.locale.translate('global.aceptar'),
            metadata: {
              icon: 'check',
              style: 'primary fill',
            },
            cols: 8,
          },
        ],
      },
      getIntroAlertObject('viewdoc.step.intro.info', 'viewdoc.step.intro.info2'),
    ],
  };
}

export function getViewdocsViewAlert() {
  return document.querySelector('ewc-alert[view-name="viewdocsAlert"]');
}

export function getViewdocsViewBtnSubmit() {
  return document.querySelector('ewc-button[view-name="btnSubmit"]');
}

export function hideViewdocsError() {
  const eAlert = getViewdocsViewAlert();
  setElementVisible(eAlert, false);
}

export function showViewdocsError(message) {
  const eAlert = getViewdocsViewAlert();
  setElementVisible(eAlert, true);
  eAlert.innerHTML = edicom.locale.translate(message);
}
